import { SelectItem } from '@/types/ui';
import dayjs, { Dayjs } from 'dayjs';

export const getSingleDateFilterOptions = (): SelectItem<Dayjs>[] => [
  {
    label: 'Custom',
    value: dayjs(),
    additionalInfo: 'Choose your date',
  },
];

export default getSingleDateFilterOptions;
